import { Skeleton } from "@mui/material";
import React, { FC } from "react";

const DrawerSkeleton: FC = () => {
  return (
    <Skeleton
      sx={{
        height: 204,
        borderRadius: "1rem",
        transform: "none",
        marginBottom: "1rem",
      }}
    />
  );
};

export default DrawerSkeleton;
